import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import UseContentRedactionsQuery, {
	type useContentRedactionsQuery$data,
	type useContentRedactionsQuery$variables,
} from './hooks/__generated__/useContentRedactionsQuery.graphql.ts';

interface PreloadRedactionsQueriesI {
	contentId: string;
	canUpdateContent: boolean;
}

export const preloadRedactionsQueries = async ({
	contentId,
	canUpdateContent,
}: PreloadRedactionsQueriesI) => {
	if (!contentId || !canUpdateContent) {
		return;
	}

	return query<useContentRedactionsQuery$data, useContentRedactionsQuery$variables>({
		query: UseContentRedactionsQuery,
		variables: { contentId },
		errorPolicy: 'all',
	});
};
